import styled from "styled-components";

/** A row of buttons in one pill, the active one filled: the Monitored URI chart's toggles, the Issues sort. */
export const SegmentedRow = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 3px;
`;

export const SegmentedButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 3px 9px;
    border-radius: 5px;
    border: none;
    background: ${({ $active }) => $active ? '#6366f1' : 'transparent'};
    color: ${({ $active }) => $active ? '#fff' : '#64748b'};
    font-size: 0.7rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 120ms, color 120ms;
    &:hover { background: ${({ $active }) => $active ? '#6366f1' : '#ede9fe'}; color: ${({ $active }) => $active ? '#fff' : '#6366f1'}; }
`;
